import React,{useEffect,useState} from 'react'

const Calender = ({setValue}) => {
    const [date, setDate] = useState('');

    useEffect(() => {
      const today = new Date().toISOString().split('T')[0]
      setDate(today)
    }, [])
    
  return (
    <div>
      <input type='date' value={date} className='calender' 
        onChange={(e) => {
            setDate(e.target.value)
            setValue(e.target.value)
        }}
      />
    </div>
  )
}

export default Calender
